import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'
import { authPaths } from '@modules/auth'
import { hasActiveSession } from '@core/auth/session'
import { publicSigningRoutes } from '@modules/publicSigning/publicSigningRoute'
import { ownerOnboardingRoutes } from '@modules/ownerOnboarding'

// Pre-auth routes mounted under the AuthLayout shell.
//
// Seed set: the `/` hand-off, the error page, and the catch-all 404.
// As you build public-facing modules (auth, landing, …), spread their
// published route collections in here — e.g. `...authRoutes`.
export const publicRoutes: RouteRecordRaw[] = [
  {
    // `/` is a hand-off, not a screen — the seller portal has no public landing
    // page. A live session goes to the dashboard; everyone else to the single
    // UAE PASS sign-in screen. This also covers the "Home" affordances in
    // AppTopNav / ErrorPage / NotFoundPage, which all push `routes.HOME`.
    path: routes.HOME,
    name: 'HOME',
    redirect: () => ({ path: hasActiveSession() ? routes.DASHBOARD : authPaths.LOGIN }),
  },
  {
    path: routes.ERROR,
    name: 'ERROR',
    component: () => import('@app/pages/ErrorPage.vue'),
  },
  ...publicSigningRoutes,
  ...ownerOnboardingRoutes,
  {
    path: '/:pathMatch(.*)*',
    name: 'NOT_FOUND',
    component: () => import('@app/pages/NotFoundPage.vue'),
  },
]
